export const assertCrmExportReady = (response, expected) => {
  const data = response?.data;
  const object = value => value && typeof value === 'object' && !Array.isArray(value);
  const valid = expected === 'landing' ? object(data?.landing)
    : expected === 'board' ? object(data?.board?.columns)
      : expected === 'items' ? Array.isArray(data?.items) && typeof data.hasMore === 'boolean' && (!data.hasMore || data.items.length > 0)
        : Boolean(data);
  if (!response || response.status >= 400 || !valid) throw new Error('Could not export contacts. Please try again.');
};
